<template>
    <div>
        <div class="simple-form" v-if="!viewMode">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">归类标签</label>
                </div>
                <div class="form-value">
                    <el-input class="bottom-line width-1-5x" v-model="classifyTagName" :disabled="true"></el-input>
                    <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择归类标签" @click="selectTag()"></i>
                </div>
            </div>
        </div>
        <swb-prop-editor ref="prop_editor" :name="'demo-prop-editor'" :widthForLabel='150' :propList="propList" :viewMode="viewMode"></swb-prop-editor>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { showDevcClassifyTagListSelectDlg } from './selectDlg'

    import SwbPropEditor from '../ctrl/PropEditor';
    Vue.regist(SwbPropEditor);

    import merchtComnApi from '../../api/merchtComn'
    import shopDevcApi from '../../api/shopDevc'
    import devcApi from '../../api/devc'

    export default {
        name: 'swb-devc-cust-info-save',
        props: {
            devcId: {// devcId 设备id 单个设备设置时用于回显
                type: Number,
                default: null
            },
            viewMode: {//是否查看模式
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                classifyTagId: null,
                classifyTagName: null,
                propList: [],
                devcCustFieldList: [],
                devcCustFieldMap: {}
            }
        },
        created: function () {
            this.getDevcCustFieldList();
            if(this.devcId != null) {
                this.getShopDeviceInfo();
            }
        },
        methods: {
            getShopDeviceInfo: function () {
                let self = this;
                let postData = {
                    id: this.devcId,
                    containMgmt: true,
                    containAsset: true,
                    containMaint: true,
                };
                let theLoad = MsgBox.loading();
                devcApi.getShopDeviceById(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let shopDeviceSubNo = result.data;
                        self.classifyTagId = shopDeviceSubNo.classifyTagId;
                        self.classifyTagName = shopDeviceSubNo.classifyTagName;
                        self.getTagSpecField(function () {
                            self.getDevcCustInfo();
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDevcCustInfo(){
                let self = this;
                let postData = {};
                postData.id = this.devcId;
                let theLoad = MsgBox.loading();
                shopDevcApi.getDevcCustInfo(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let devcCustInfo = result.data;
                        let custJson = JSON.decode(devcCustInfo.custJson);
                        let propList = self.propList;
                        propList.forEach(function (prop) {
                            if(!Utils.isNoB(custJson[prop.code])) {
                                prop.value = custJson[prop.code];
                            }
                        });
                        self.propList = Utils.merge([], propList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectTag(){
                let self = this;
                showDevcClassifyTagListSelectDlg(function (tag) {
                    if(self.classifyTagId != tag.id) {
                        self.classifyTagId = tag.id;
                        self.classifyTagName = tag.name;
                        self.getTagSpecField(function () {
                        });
                    }
                });
            },
            getDevcCustFieldList(){
                let self = this;
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcCustFieldList({}, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let devcCustFieldList = result.data;
                        self.devcCustFieldList = devcCustFieldList;
                        self.devcCustFieldMap = devcCustFieldList.toMap('id');
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTagSpecField(callback){
                let self = this;
                let postData = {};
                postData.classifyTagId = this.classifyTagId;
                //
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcClassifyTagSpecFields(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let devcCustFieldMap = self.devcCustFieldMap;
                        let tagSpecFieldList = result.data;
                        let propList = [];
                        tagSpecFieldList.forEach(function (tagField) {
                            let field = devcCustFieldMap[tagField.custFieldId];
                            propList.push({
                                label: field.title,
                                code: field.name,
                                valueType: field.type,
                                tooltip: field.desc,
                                required: tagField.required
                            });
                        });
                        self.propList = Utils.merge([], propList);
                        callback();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult() {
                let classifyTagId = this.classifyTagId;
                let classifyTagName = this.classifyTagName;
                let result = {};
                let resultData = {};
                resultData.classifyTagId = classifyTagId;
                resultData.classifyTagName = classifyTagName;
                if(classifyTagId != null && classifyTagId != -1) {
                    let propEditor = this.$refs['prop_editor'];
                    if(propEditor.validate()) {
                        resultData.devcCustInfo = propEditor.getPropValues();
                        result.data = resultData;
                        result.type = 'info';
                    } else {
                        result.type = 'wran';
                    }
                } else {
                    result.data = resultData;
                    result.type = 'info';
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcCust/DevcCustInfoSave.vue